import React from 'react';
export function PaymentBadges({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-wrap items-center justify-center gap-2 ${className}`} data-id="element-212">
      {/* Visa */}
      <div className="bg-[#1434CB] text-white text-xs font-bold italic px-3 py-1.5 rounded-md shadow-sm select-none" data-id="element-213">
        VISA
      </div>
      {/* Mastercard */}
      <div className="bg-gray-100 border border-gray-200 text-gray-800 text-xs font-bold px-3 py-1.5 rounded-md shadow-sm flex items-center gap-1 select-none" data-id="element-214">
        <div className="flex -space-x-1.5" data-id="element-215">
          <div className="w-3 h-3 rounded-full bg-[#EB001B] opacity-80" data-id="element-216"></div>
          <div className="w-3 h-3 rounded-full bg-[#F79E1B] opacity-80" data-id="element-217"></div>
        </div>
        mastercard
      </div>
      {/* PayPal */}
      <div className="bg-[#003087] text-white text-xs font-bold italic px-3 py-1.5 rounded-md shadow-sm select-none" data-id="element-218">
        PayPal
      </div>
      {/* Amex */}
      <div className="bg-[#2E77BC] text-white text-xs font-bold px-3 py-1.5 rounded-md shadow-sm select-none" data-id="element-219">
        AMEX
      </div>
      {/* Apple Pay */}
      <div className="bg-black text-white text-xs font-bold px-3 py-1.5 rounded-md shadow-sm flex items-center gap-1 select-none" data-id="element-220">
        <span className="text-[10px]" data-id="element-221"></span> Pay
      </div>
    </div>;
}